import { useRouter } from 'next/router'
import { labList } from '~/configs/ai'
import { OptionsTabs } from '../OptionsTabs'
import { useState } from 'react'

export const LabTabs = () => {
  const router = useRouter()
  /** 已上线的AI实验室 */
  const labTabData = labList.filter(item => !!item.link)
  const index = labTabData.findIndex(item => item.link === router.pathname)

  const [currentIndex, setCurrentIndex] = useState(index)

  return (
    <OptionsTabs
      options={labTabData.map(item => {
        return {
          label: item.title,
          isNew: item?.isNew,
        }
      })}
      currentIndex={currentIndex}
      setCurrentIndex={setCurrentIndex}
      onChange={index => {
        router.push(labTabData[index]?.link!)
      }}
    />
  )
}
